/**
 * Mixin for Backbone.View
 * Makes it a parent which manages subviews
 *
 * TODOs:
 * - [ ] Listen for subview remove events and remove them from list
 * - [ ] Refactor to be a class
 * - [ ] Rename to subview manager
 */
import * as _ from "underscore";

export default {
  setSubviews: function (newSubviews) {
    this.removeSubviews();
    this.subviews = newSubviews;
  },
  /**
   * @param {string} name
   * @param {any} subview // Backbone.View
   */
  addSubview: function (name, subview) {
    this.subviews = this.subviews || {};
    if (this.subviews[name] && this.subviews[name].remove) {
      this.subviews[name].remove();
    }
    this.subviews[name] = subview;
  },
  removeSubview: function (name) {
    if (this.subviews && this.subviews[name]) {
      this.subviews[name].remove();
      delete this.subviews[name];
    }
  },
  removeSubviews: function () {
    if (!this.subviews) {
      return;
    }
    _.each(this.subviews, function (subview, name) {
      if (subview && subview.remove) {
        subview.remove();
      } else {
        console.error("no remove() function on subview: ", name);
      }
    });
    this.subviews = {};
  },
  remove: function (...args: any[]) {
    this.removeSubviews();
    Object.getPrototypeOf(this).remove.apply(this, args);
  },
};
